import { SearchQuery, SearchResult, NoteRecord, OfflineRecord } from "./types";
import { parseOfflineQuery } from "./offline_query_parser";
import { OfflineSearchEngine } from "./offline_search_core";
import { getNotes } from "./offline_storage";

function noteToOffline(r: NoteRecord): OfflineRecord {
  return {
    id: r.id,
    recordType: r.path === "B" ? "report" : "conversation",
    recordDate: new Date(r.createdAt).toISOString(),
    employeeName: r.entities.employee ?? "",
    title: r.title,
    shortSummary: r.shortNote,
    transcript: r.transcript,
    tokens: r.entities.topic ? [r.entities.topic] : [],
    topic: r.entities.topic,
    location: r.entities.location,
    arrangements: r.entities.arrangement ? [{ what: r.entities.arrangement }] : []
  };
}

export function search(records: NoteRecord[], query: SearchQuery): SearchResult[] {
  const engine = new OfflineSearchEngine();
  engine.buildIndex(records.map(noteToOffline));
  const parsed = parseOfflineQuery(query.text);
  return engine.search(parsed);
}

let offlineEngine: OfflineSearchEngine | null = null;

export async function searchOffline(query: SearchQuery): Promise<SearchResult[]> {
  const notes = await getNotes();
  if (!offlineEngine) {
    offlineEngine = new OfflineSearchEngine();
    offlineEngine.buildIndex(notes.map(noteToOffline));
  } else {
    offlineEngine.buildIndex(notes.map(noteToOffline));
  }
  const parsed = parseOfflineQuery(query.text);
  return offlineEngine.search(parsed);
}
